// session key
export const OPEN_SCREEN_DIALOG_SESSION = 'OPEN_SCREEN_DIALOG_SESSION';

// key
export const DIALOG_FIRST_DISCOUNT = 'FIRST_DISCOUNT';
export const DIALOG_GOOGLE_ADS = 'GOOGLE_ADS';
export const DIALOG_USE_CLAW_ONLINE = 'USE_CLAW_ONLINE';
export const DIALOG_RETENTION_EXPIRING = 'RETENTION_EXPIRING';
export const DIALOG_RETENTION_LAST_DAY = 'RETENTION_LAST_DAY';
export const DIALOG_MULTI_GRID_TRIAL = 'MULTI_GRID_TRIAL';
export const DIALOG_COUPON_EXPIRING = 'COUPON_EXPIRING';
export const DIALOG_VIP_TRIAL = 'VIP_TRIAL';
export const DIALOG_DOUBLE_FESTIVAL = 'DOUBLE_FESTIVAL_2026';
export const DIALOG_Q4_LAUNCH = 'Q4_LAUNCH_2026';

/** 优惠券快到期弹窗：已弹过的 coupon id 列表（localStorage） */
export const COUPON_EXPIRING_SHOWN_IDS_KEY = 'COUPON_EXPIRING_SHOWN_IDS';

/**
 * 开屏弹窗埋点名：`home_popup_click` 事件的 `popup_name` 参数，按弹窗 key 登记。
 *
 * ⚠️ 新增开屏弹窗时（除加入 ALL_OPEN_SCREEN_DIALOGS 外）必须：
 * 1. 在此登记该弹窗的 popup_name；
 * 2. 在弹窗 CTA 按钮点击处调用 `reportHomePopupClick(dialogKey)`（见 ./utils）。
 */
export const POPUP_NAMES: Record<string, string> = {
  [DIALOG_Q4_LAUNCH]: 'q4_launch',
  [DIALOG_DOUBLE_FESTIVAL]: 'double_festival',
  [DIALOG_MULTI_GRID_TRIAL]: 'multi_grid_trial',
  [DIALOG_FIRST_DISCOUNT]: 'first_discount',
  [DIALOG_GOOGLE_ADS]: 'google_ads',
  [DIALOG_RETENTION_EXPIRING]: 'retention_expiring',
  [DIALOG_RETENTION_LAST_DAY]: 'retention_last_day',
  [DIALOG_COUPON_EXPIRING]: 'coupon_expiring',
  [DIALOG_VIP_TRIAL]: 'vip_trial',
  [DIALOG_USE_CLAW_ONLINE]: 'use_claw',
};

/**
 * 所有要展示的开屏弹窗（顺序由 NOTIFICATION_PRIORITIES 配置，此处顺序不影响）
 * 当有新增开屏弹窗时添加数组
 */
export const ALL_OPEN_SCREEN_DIALOGS = [
  DIALOG_Q4_LAUNCH,
  DIALOG_DOUBLE_FESTIVAL,
  // DIALOG_USE_CLAW_ONLINE 已下线（组件与文案保留，如需恢复加回此列表即可）
  DIALOG_MULTI_GRID_TRIAL,
  DIALOG_FIRST_DISCOUNT,
  DIALOG_GOOGLE_ADS,
  DIALOG_RETENTION_EXPIRING,
  DIALOG_RETENTION_LAST_DAY,
  DIALOG_COUPON_EXPIRING,
  DIALOG_VIP_TRIAL,
];

/** 挽留开屏弹窗展示次数 key */
export const RETENTION_SCREEN_EXPIRING_COUNT_KEY = 'RETENTION_SCREEN_EXPIRING_COUNT';

/** 挽留开屏弹窗最多展示次数（Phase2） */
export const MAX_RETENTION_SCREEN_COUNT = 3;

/**
 * 弹窗优先级配置
 * 数字越大优先级越高，建议使用10的倍数便于插入新的优先级
 */
export const NOTIFICATION_PRIORITIES = {
  /**
   * @popupTitle Vidu Q4 上线
   * @popupSite both
   * @popupStart 2026-10-06
   * @popupEnd 2026-10-13
   * @popupCondition 国内外站点 + 非企业分发 + 首页路径 + 活动期内
   * @popupFrequency 本地自然日每天 1 次
   * @popupFigma https://www.figma.com/design/SIDn1gNJEGhPMgKzkfZueQ?node-id=41752-4519
   * @popupNote 10 月 6 日起展示无促销文案版；海外 10 月 7 日 21:00、国内 10 月 8 日 09:00（北京时间）起展示促销版
   */
  [DIALOG_Q4_LAUNCH]: 110,
  /**
   * @popupTitle 双节礼遇 · 会员折扣
   * @popupSite both
   * @popupEnd 2026-10-01
   * @popupCondition 国内外站点 + 非企业分发 + 首页路径 + 双节宣传开关开启 + 展示时间内
   * @popupFrequency 每天 1 次，沿用全局 24 小时与会话频控
   * @popupFigma https://www.figma.com/design/SIDn1gNJEGhPMgKzkfZueQ?node-id=41630-4182
   * @popupNote 按站点切换中英文素材和权益金额；UTC 2026-10-01 16:00 自动下线；点击进入 /subscription/personal；首次登录欢迎弹窗仍优先
   */
  [DIALOG_DOUBLE_FESTIVAL]: 100,
  /**
   * @popupTitle 取消续费挽留 - 最后一天
   * @popupSite china
   * @popupCondition 已取消续费（且未在提前续费冷却期）+ 距到期 ≤ 1 天 + 首页路径
   * @popupFrequency 仅一次（hasShownDialogs 持久化）
   * @popupNote 对应 useRetentionStrategy 的 phase3
   */
  [DIALOG_RETENTION_LAST_DAY]: 99,
  /**
   * @popupTitle 取消续费挽留 - 临期 7 天
   * @popupSite china
   * @popupCondition 已取消续费（且未在提前续费冷却期）+ 距到期 1~7 天 + 首页路径
   * @popupFrequency 最多 3 次，间隔 ≥ 1 天
   * @popupNote 对应 useRetentionStrategy 的 phase2；MAX_RETENTION_SCREEN_COUNT = 3
   */
  [DIALOG_RETENTION_EXPIRING]: 98,
  /**
   * @popupTitle Claw 上线使用引导
   * @popupSite both
   * @popupCondition 首页路径（当前未额外校验是否拥有 claw）
   * @popupFrequency 每天 1 次
   * @popupNote 代码注释提示后续应等 GetMyClaws 拉完再判断，避免给已有 claw 的用户重复弹；目前尚未实现该校验；依据 SITE 切换中英文素材
   */
  [DIALOG_USE_CLAW_ONLINE]: 97,
  /**
   * @popupTitle 多宫格创作功能试用
   * @popupSite global
   * @popupStart 2026-05-29
   * @popupEnd 2026-06-29
   * @popupCondition 首页路径 + 活动期内
   * @popupFrequency 每天 1 次
   * @popupNote 通过 OpenScreenDialog 常规调度展示，文案在 MultiGridTrialDialog 内依据 locale 切换
   */
  [DIALOG_MULTI_GRID_TRIAL]: 99,
  /**
   * @popupTitle 首期折扣弹窗
   * @popupSite both
   * @popupCondition 首页路径 + useUserNexus.isSubOneTimeOffer
   * @popupFrequency 最多 5 次，间隔 ≥ 1 周
   * @popupNote 第 5 次展示后写入 hasShownDialogs 永久关闭，并清除计数；依据 SITE 切换中英文素材
   */
  [DIALOG_FIRST_DISCOUNT]: 85,
  /**
   * @popupTitle Google Ads 弹窗
   * @popupSite both
   * @popupCondition 当前会话未访问过 + 当日会话数 < 3 + 非根路径 + useAdsDialog 命中投放（isEligible === true）
   * @popupFrequency 每日 ≤ 3 次，每会话 1 次
   * @popupNote 在主会话 24h 限频内仍可放行；最终展示取决于后端广告投放规则
   */
  [DIALOG_GOOGLE_ADS]: 83,
  /**
   * @popupTitle 优惠券快到期了
   * @popupSite both
   * @popupCondition 有未使用且即将到期（≤ 2 天）的优惠券，且该券尚未弹过
   * @popupFrequency 每张券一次（per-coupon-id 写入 COUPON_EXPIRING_SHOWN_IDS）
   */
  [DIALOG_COUPON_EXPIRING]: 99,
  /**
   * @popupTitle 7 天 VIP 试用优惠
   * @popupSite global
   * @popupCondition 海外站 + 首页路径 + 非团队空间 + 未订阅用户（subs_plan === 'free'）+ 具备首购优惠资格 + 非 t1 地区
   * @popupFrequency 每天 1 次
   * @popupFigma https://www.figma.com/design/SIDn1gNJEGhPMgKzkfZueQ/%E3%80%90SaaS-web%E3%80%913.0?node-id=40526-59966
   * @popupNote 点击「Try for $4.99」跳订阅页试用 tab（subscription-period=paid_trial）；仅英文素材，故只在 global 站展示
   */
  [DIALOG_VIP_TRIAL]: 99,
};
